import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";

const cardVariants = {
  hidden: { opacity: 0, y: 60, scale: 0.96 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.7, ease: "easeOut" },
  },
};

export default function MissionVisionSection() {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 6, md: 9 },
        background: "#fff",
      }}
    >
      <Container maxWidth="md">
        <Grid
          container
          spacing={{ xs: 3.5, md: 4 }}
          justifyContent="center"
        >
          <Grid item xs={12} md={6}>
            <motion.div
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
            >
              <Box
                sx={{
                  p: { xs: 2.8, md: 3.2 },
                  borderRadius: "26px",
                  background:
                    "linear-gradient(160deg,#161618 0%,#1c1c1f 100%)",
                  border: "1px solid rgba(255,255,255,0.06)",
                  boxShadow:
                    "0 22px 60px rgba(0,0,0,0.35)",
                  transition: ".35s ease",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 13,
                    fontWeight: 800,
                    letterSpacing: 1.3,
                    color: "#ff2a2a",
                    textTransform: "uppercase",
                  }}
                >
                  Misión
                </Typography>

                <Typography
                  sx={{
                    mt: 1.2,
                    fontSize: { xs: 22, md: 24 },
                    fontWeight: 900,
                    color: "#ffffff",
                    lineHeight: 1.2,
                  }}
                >
                  Transformar vidas a través del entrenamiento
                </Typography>

                <Typography
                  sx={{
                    mt: 1.6,
                    fontSize: { xs: 15.2, md: 16.5 },
                    lineHeight: 1.8,
                    color: "rgba(255,255,255,0.78)",
                    fontWeight: 500,
                  }}
                >
                  Brindar un servicio de entrenamiento integral con acompañamiento
                  profesional, ayudando a cada persona a construir hábitos
                  saludables, fortalecer su salud muscular y mejorar su bienestar
                  de forma segura y efectiva.
                </Typography>

                <Box
                  sx={{
                    mt: 2,
                    width: 40,
                    height: 3,
                    borderRadius: 2,
                    background:
                      "linear-gradient(90deg,#e50914,#ff2a2a)",
                  }}
                />
              </Box>
            </motion.div>
          </Grid>

          <Grid item xs={12} md={6}>
            <motion.div
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
            >
              <Box
                sx={{
                  p: { xs: 2.8, md: 3.2 },
                  borderRadius: "26px",
                  background:
                    "linear-gradient(160deg,#0f0f10 0%,#1b0b0c 100%)",
                  border: "1px solid rgba(229,9,20,0.28)",
                  boxShadow:
                    "0 24px 65px rgba(229,9,20,0.18)",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: -70,
                    right: -70,
                    width: 220,
                    height: 220,
                    borderRadius: "50%",
                    background:
                      "radial-gradient(circle, rgba(229,9,20,0.28) 0%, transparent 70%)",
                  }}
                />

                <Typography
                  sx={{
                    fontSize: 13,
                    fontWeight: 800,
                    letterSpacing: 1.3,
                    color: "rgba(255,255,255,0.72)",
                    textTransform: "uppercase",
                  }}
                >
                  Visión
                </Typography>

                <Typography
                  sx={{
                    mt: 1.2,
                    fontSize: { xs: 22, md: 24 },
                    fontWeight: 900,
                    color: "#ffffff",
                    lineHeight: 1.2,
                  }}
                >
                  Ser una comunidad que impulsa el cambio real
                </Typography>

                <Typography
                  sx={{
                    mt: 1.6,
                    fontSize: { xs: 15.2, md: 16.5 },
                    lineHeight: 1.8,
                    color: "rgba(255,255,255,0.82)",
                    fontWeight: 500,
                  }}
                >
                  Consolidarnos como un espacio donde las personas no solo entrenan,
                  sino crecen, se superan y desarrollan su mejor versión, respaldadas
                  por un enfoque profesional y un acompañamiento integral en su
                  proceso.
                </Typography>

                <Box
                  sx={{
                    mt: 2,
                    width: 40,
                    height: 3,
                    borderRadius: 2,
                    background:
                      "linear-gradient(90deg,#e50914,#ff2a2a)",
                  }}
                />
              </Box>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}